
import { TiposIdentificacion } from "@pcgerente-node/pcg-comun";
import { numerosNaturales } from "./regex";

export const obtenerTipoIdentificacion =(cedula: string) => {
    let retorno = 0
    if(cedula.length === 10 && numerosNaturales(cedula)){
      retorno = TiposIdentificacion.Cedula
    }
    else if(cedula.length === 13 && numerosNaturales(cedula)){
      retorno = TiposIdentificacion.RUC
    }else {
      retorno = TiposIdentificacion.Pasaporte
    }
    return retorno
  }